
import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ApiLoginService } from 'src/app/services/login/api-login.service';
import { Login } from 'src/app/interfaces/login';
import { LocalstorageService } from 'src/app/services/storage/localstorage.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  @Input() usuarioAutenticado: boolean = false;

  usuarioStorage: any = {};

  usuarioLogado:Login = {} as Login
  versaoSistema:any = ''
  versaoFrontEnd:any = ''
  admPerm:any = ''
  parametrosPendentes:boolean = false;
  // rotaSelecionada:string = '';



  constructor(
    private router: Router,
    private location: Location,
    public apiLogin: ApiLoginService,
    public localStorage: LocalstorageService,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    const _self = this;
    this.http.get("assets/config.json?" + Math.random()).subscribe( async data => {
      let versaoFrontEnd = JSON.parse(JSON.stringify(data))
      _self.versaoFrontEnd = versaoFrontEnd.versaoFrontEnd;
    })

    this.getUsuarioStorage();
    // this.getLoginStorage();
    
    this.getVersao();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        let rota = String(this.router.url);
        if(rota.includes(';')){
          rota = rota.split(';')[0];
        }
        if (this.usuarioAutenticado && rota == '/login') {
          this.location.forward();
        }

        let sidebar = document.getElementById('sidebar-menu') || document.createElement('div');
        let btnToggle = document.getElementsByClassName('btn-toggle');
        let isMobile = getComputedStyle(sidebar).position == 'relative' ? false : true;

        let menus = document.getElementsByClassName('btn-menu');
        for (let i = 0; i < menus.length; i++) {
          menus[i].classList.remove('active-menu');
        }

        let elemParam = document.getElementById(rota.replace('/', ''));
        
        let parentParam = null
        if (elemParam?.tagName != 'BUTTON') {
          parentParam = elemParam?.parentElement?.parentElement?.parentElement?.firstChild;
        }

        for (let i = 0; i < btnToggle.length; i++) {
          let menuAux: HTMLElement = btnToggle[i] as HTMLElement;
          let isMenu = menuAux?.classList.contains('btn-menus');
          
          let isOpen = menuAux.getAttribute('aria-expanded');
          if(isMenu && isOpen == 'true'){
            menuAux.click();
            if (isMobile) {
              this.showMenu();
            }
          }

        }
        
        elemParam?.classList.add('active-menu');

      }
   })

  }
  
  ParamPend(rota:string){
    this.parametrosPendentes = JSON.parse(this.localStorage.getData('PARAM_PEND'))
    if(!this.parametrosPendentes){
      this.router.navigate(['/'+rota]);
    }else{
      this.localStorage.setData('ROTA', rota)
      document.getElementById('show-modal_menu')?.click()
    }
  }
  
  getVersao(){
    const _self = this;
    this.apiLogin.versaoXML()
    .then(versaoStorage => {
        if (versaoStorage != undefined) {
          _self.versaoSistema = versaoStorage;
        }
      })
      .catch(erro => {
        console.warn('app.component.ts - erro ao buscar usuario no datastorage: ', erro)
      })  
    }

  showMenu(){
    let sidebar_classList = document.getElementById('sidebar-menu') || document.createElement('div');
    let isMobile = getComputedStyle(sidebar_classList).position == 'relative' ? false : true;

    if(sidebar_classList?.classList.contains('hide') && !isMobile){
      sidebar_classList?.classList.remove('hide');
      sidebar_classList?.classList.add('open');
    }else {
      sidebar_classList?.classList.add('hide');
    }
  }

  ngOnChanges() {
    if (this.usuarioAutenticado == true) {
      this.getUsuarioStorage();
    }
  }

  btnAtivo(id: string){
    let menus = document.getElementsByClassName('btn-menu');
    for (let i = 0; i < menus.length; i++) {
      menus[i].classList.remove('active-menu');
    }

    document.getElementById(id)?.classList.add('active-menu');
    this.showMenu();
  }

  collapseMenuMobile() {
    let menus = document.getElementsByClassName('btn-menus');
    const sidebar_classList = document.getElementById('sidebar-menu');
    if(sidebar_classList?.classList.contains('hide') || (!sidebar_classList?.classList.contains('open') && !sidebar_classList?.classList.contains('hide'))){
      sidebar_classList?.classList.add('open');
      sidebar_classList?.classList.remove('hide');
    }else {
      sidebar_classList?.classList.add('hide');
      for (let i = 0; i < menus.length; i++) {
        if (!menus[i].classList.contains('collapsed')) {
          let element: HTMLElement = menus[i] as HTMLElement;
          element.click();
        };
      }
    }
  } 

  getUsuarioStorage() {
    const _self = this;
    var permissoes = JSON.parse(_self.localStorage.getData('PERMISSOES'));
    
    if(permissoes.permissoes != undefined){
      var menu = JSON.parse(_self.localStorage.getData('USUARIO'));
      
      if(menu.length != 0){
        menu = menu.perfil.listaMenu
      }
      for(let i = 0; i < menu.length; i++){
        switch(menu[i].id){
          case 1:
            this.apiLogin.listaMenuPerfil.cadastro = true
            break;
          case 2:
            this.apiLogin.listaMenuPerfil.consultas = true
            break;
          case 3:
            this.apiLogin.listaMenuPerfil.configuracoes = true
            break;
          case 4:
            this.apiLogin.listaMenuPerfil.regras = true
            break;
          case 5:
            this.apiLogin.listaMenuPerfil.pendencias = true
            break;
        }
      }

      permissoes = permissoes.permissoes
      for(let i = 0; i < _self.apiLogin.listaSubMenus.length; i++){
        for(let j = 0; j < permissoes.length; j++){
          if(_self.apiLogin.listaSubMenus[i].id == permissoes[j].id_nfer_menu){
             _self.apiLogin.listaSubMenus[i].hidden = true
          }
        }
      }
    }
  }

}
